var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 8.75,
    viewBox: "0 0 15 8.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-forward",
    "data-name": "Icon ionic-ios-arrow-forward",
    d: "M6.112,7.5.321,1.825a1.053,1.053,0,0,1,0-1.514,1.119,1.119,0,0,1,1.549,0L8.431,6.738a1.055,1.055,0,0,1,.032,1.478L1.875,14.687a1.116,1.116,0,0,1-1.549,0,1.053,1.053,0,0,1,0-1.514Z",
    transform: "translate(15) rotate(90)",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.13a0032e93a30f1b8b34e4b7a8130cbb.svg";
export { ForwardRef as ReactComponent };